<template lang="pug"
src='./walls-tab-addition.pug'>

</template>

<script>
import saveBtn from '@/common/components/saveBtn.vue'
import imgIcon from '@/common/img/baseline-clear-24px.svg'
export default {
	name: 'walls-addition',
	props: ['project', 'control', 'readonly', 'findControlTextByKey'],
	components: { saveBtn },
	data () {
		return {
			imgIconDel: imgIcon,
			typeLabel: 'Addition',
			doorArea: 'Addition Door Area',
			perimLength: 'Addition Perimeter Length'
		}
	},
	created () {
		// How many perimeters we have now
		const currentPerimeters = this.project.walls.perimeters.length
		// How many perimeters we need to have
		const maxPerimNumber = Math.max(this.project.numStories, this.project.addition.numStoriesAdtn)

		// Need to add perimeters?
		if (maxPerimNumber > currentPerimeters) {
			// How many we need to add
			const numPerimMiss = maxPerimNumber - currentPerimeters

			// Create an array containing the perimeter objects that we need
			const perimsToAdd = Array.from(
				{ length: numPerimMiss },
				() => ({
					existing: {
						// Front, Left, Back, Right, Adjacent to attic, Adjacent to garage
						values: [{value: '0.0'}, {value: '0.0'}, {value: '0.0'}, {value: '0.0'}, {value: '0.0'}, {value: '0.0'}],
						// Below grade Retaining wall
						// Length, Avg.Depth
						wall: [{value: ''}, {value: ''}]
					},
					addition: {
						// Front, Left, Back, Right, Adjacent to attic, Adjacent to garage
						values: [{value: '0.0'}, {value: '0.0'}, {value: '0.0'}, {value: '0.0'}, {value: '0.0'}, {value: '0.0'}],
						// Below grade Retaining wall
						// Length, Avg.Depth
						wall: [{value: ''}, {value: ''}]
					},
					garage: { // if apply
						// Front, Left, Back, Right, Adjacent to attic, Adjacent to garage
						values: [{value: '0.0'}, {value: '0.0'}, {value: '0.0'}, {value: '0.0'}],
						// Below grade Retaining wall
						// Length, Avg.Depth
						wall: [{value: ''}, {value: ''}]
					}
				})
			)

			// Add perimeters to existing
			this.project.walls.perimeters.push(...perimsToAdd)

		// Need to remove unnecessary perimeters?
		} else if (maxPerimNumber < currentPerimeters) {
			// Then how many perimeters we need to remove
			const perimToDel = this.project.walls.perimeters.length - maxPerimNumber
			// Remove perimeters accordingly from array
			this.project.walls.perimeters.splice(-Math.abs(perimToDel), perimToDel)
		}

		this.projType = process.env.PROJTYPE
		if (this.project.takeoff === this.projType.conversion) {
			this.typeLabel = 'Conversion'
			this.doorArea = 'Conversion Door Area'
			this.perimLength = 'Conversion Perimeter Length'
		} else if (this.project.takeoff === this.projType.remodel) {
			this.typeLabel = 'Remodeled'
			this.doorArea = 'New Door Area'
			this.perimLength = 'Remodeled Perimeter Length'
		} else {
			this.typeLabel = 'Addition'
			this.doorArea = 'Addition Door Area'
			this.perimLength = 'Addition Perimeter Length'
		}
	},
	methods: {
		deleteOtherWalls (index) {
			this.project.walls.other.splice(index, 1)
		},
		addOtherWall () {
			this.project.walls.other.push(
				{
					// EXS = Existing wall to remain, ADN = New wall for addition, UPD = Existing wall upgraded to addition level
					adtnState: 'EXS',
					insul: 'BG.13',
					orient: 'Left,Yes,HOUSE',
					area: '0.0'
				}
			)
		},
		getXwallInsul (value) {
			const result = []
			this.control.xWall_insul.map(selectValue => {
				if (selectValue.current || selectValue.value === value) {
					result.push(selectValue)
				}
			})
			// console.log('control.xWall_insul ', result)
			return result
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/take-off-tool/tabs-components/walls-tab-addition.vue